import { motion } from "framer-motion";
import React from "react";
import { certification, projects, user } from "../../../static/data";
import { Button } from "../../ButtonElements";
import { SectionSubtitle, SectionTitle } from "../../SectionTitleElements";
import {
  AboutBox,
  AboutContainer,
  AboutData,
  AboutDesc,
  AboutIcon,
  AboutInfo,
  AboutSection,
  AboutSubTitle,
  AboutTitle,
  Hire,
} from "./AboutElements";
import { COLORS } from "../../../const/colors";

const About = ({ darkMode }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <AboutSection id="about">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <SectionSubtitle>Introducing myself</SectionSubtitle>
        <SectionTitle>About Me</SectionTitle>
        <AboutContainer>
          <AboutData>
            <AboutInfo>
              <motion.div variants={itemVariants}>
                <AboutBox light={darkMode ? 1 : 0}>
                  <AboutIcon>
                    <i className="bx bx-globe"></i>
                  </AboutIcon>
                  <AboutTitle light={darkMode ? 1 : 0}>Experience</AboutTitle>
                  <AboutSubTitle light={darkMode ? 1 : 0}>
                    {user.experience}+
                  </AboutSubTitle>
                </AboutBox>
              </motion.div>

              <motion.div variants={itemVariants}>
                <AboutBox light={darkMode ? 1 : 0}>
                  <AboutIcon>
                    <i className="bx bx-briefcase-alt"></i>
                  </AboutIcon>
                  <AboutTitle light={darkMode ? 1 : 0}>Completed</AboutTitle>
                  <AboutSubTitle light={darkMode ? 1 : 0}>
                    {projects.length}+ Projects
                  </AboutSubTitle>
                </AboutBox>
              </motion.div>

              <motion.div variants={itemVariants}>
                <AboutBox light={darkMode ? 1 : 0}>
                  <AboutIcon>
                    <i className="bx bx-notepad"></i>
                  </AboutIcon>
                  <AboutTitle light={darkMode ? 1 : 0}>
                    Certified with
                  </AboutTitle>
                  <AboutSubTitle light={darkMode ? 1 : 0}>
                    {certification.length}+ Certifications
                  </AboutSubTitle>
                </AboutBox>
              </motion.div>

              <motion.div variants={itemVariants}>
                <AboutBox light={darkMode ? 1 : 0}>
                  <AboutIcon>
                    <i className="bx bx-support"></i>
                  </AboutIcon>
                  <AboutTitle light={darkMode ? 1 : 0}>Support</AboutTitle>
                  <AboutSubTitle light={darkMode ? 1 : 0}>
                    {user.support}
                  </AboutSubTitle>
                </AboutBox>
              </motion.div>
            </AboutInfo>

            <motion.div variants={itemVariants}>
              <AboutDesc light={darkMode ? 1 : 0}>
                <span
                  className={`text-[${COLORS.ORANGE}] font-semibold block mb-2`}
                >
                  Who I am
                </span>
                {user.description}
              </AboutDesc>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Hire>
                <Button to="contact" className="justify-center group">
                  Hire Me
                  <i className="bx bx-send ml-2 group-hover:translate-x-1 transition-transform"></i>
                </Button>
              </Hire>
            </motion.div>
          </AboutData>
        </AboutContainer>
      </motion.div>
    </AboutSection>
  );
};

export default About;
